import { render, staticRenderFns } from "./AutocompleteUser.vue?vue&type=template&id=5b762fa2"
import script from "./AutocompleteUser.vue?vue&type=script&lang=js"
export * from "./AutocompleteUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports